import { render, staticRenderFns } from "./BorrowingPage_Overview.vue?vue&type=template&id=9836e5fa&scoped=true&"
import script from "./BorrowingPage_Overview.vue?vue&type=script&lang=js&"
export * from "./BorrowingPage_Overview.vue?vue&type=script&lang=js&"
import style0 from "./BorrowingPage_Overview.vue?vue&type=style&index=0&id=9836e5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9836e5fa",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
